import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['value', 'input', 'list', 'option', 'empty', 'clear']

  connect() {
    this.label  = this.inputTarget.value
    this.active = -1
    this.toggleClear()
  }

  open() {
    this.inputTarget.select()
    this.show(this.optionTargets)
    this.listTarget.style.display = 'block'
  }

  close() {
    this.listTarget.style.display = 'none'
    this.inputTarget.value = this.label
    this.active = -1
  }

  filter() {
    const words = this.normalize(this.inputTarget.value).split(/\s+/).filter(Boolean)
    const visible = this.optionTargets.filter(option => {
      const haystack = option.dataset.search || this.normalize(option.dataset.label)
      return words.every(word => haystack.includes(word))
    })
    this.show(visible)
    this.listTarget.style.display = 'block'
    this.highlight(visible.length ? 0 : -1)
  }

  navigate(event) {
    const visible = this.visibleOptions()
    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault()
        if (this.listTarget.style.display !== 'block') this.open()
        this.highlight(Math.min(this.active + 1, visible.length - 1))
        break
      case 'ArrowUp':
        event.preventDefault()
        this.highlight(Math.max(this.active - 1, 0))
        break
      case 'Enter':
        event.preventDefault()
        if (visible[this.active]) this.choose(visible[this.active])
        break
      case 'Escape':
        this.inputTarget.blur()
        break
    }
  }

  pick(event) {
    event.preventDefault()
    this.choose(event.currentTarget)
  }

  reset() {
    this.valueTarget.value = ''
    this.label = ''
    this.inputTarget.value = ''
    this.submit()
  }

  choose(option) {
    this.valueTarget.value = option.dataset.value
    this.label = option.dataset.label
    this.inputTarget.value = this.label
    this.listTarget.style.display = 'none'
    this.submit()
  }

  submit() {
    this.toggleClear()
    const form = this.element.closest('form')
    if (form) form.requestSubmit ? form.requestSubmit() : form.submit()
  }

  show(visible) {
    this.optionTargets.forEach(option => { option.style.display = visible.includes(option) ? '' : 'none' })
    if (this.hasEmptyTarget) this.emptyTarget.style.display = visible.length ? 'none' : ''
  }

  visibleOptions() {
    return this.optionTargets.filter(option => option.style.display !== 'none')
  }

  highlight(index) {
    const visible = this.visibleOptions()
    visible.forEach((option, i) => option.classList.toggle('is-active', i === index))
    this.active = index
    if (visible[index]) visible[index].scrollIntoView({ block: 'nearest' })
  }

  toggleClear() {
    if (this.hasClearTarget) this.clearTarget.style.display = this.valueTarget.value ? '' : 'none'
  }

  normalize(text) {
    return (text || '').toString().normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
  }
}
